export default "__VITE_ASSET__BjpsGc96__"